const ASSET_CLASS_NAMES = {
  1: 'cash',
  2: 'fxForwards',
  3: 'mmInstruments',
  4: 'loans',
  5: 'bonds',
  6: 'equities',
  7: 'optionsDerivatives',
  8: 'alternatives',
  9: 'various',
  2924002: 'credit',
  2925002: 'limit',
  8031002: 'bonds',
  8032002: 'shares',
  8033002: 'futures',
  8034002: 'funds',
  8035002: 'swaps',
  8036002: 'commodities',
  8037002: 'options',
  8038002: 'structuredProducts',
  8039002: 'insurancePolicies',
  8042002: 'cash',
  8043002: 'others',
  8067002: 'pawn',
  8068002: 'property',
  8184002: 'mmDeposites'
};

const DOCSIGN_API_SETTIMEOUT_CODES = {
  DELAY : 300000
 };

module.exports = ASSET_CLASS_NAMES, DOCSIGN_API_SETTIMEOUT_CODES;